export default __webpack_public_path__ + "static/media/asistencia-contribuyente.a8c7a402.svg";